import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type"],
    _excluded2 = ["children", "isDismissable", "onDismiss", "size"],
    _excluded3 = ["variant", "children", "primaryActionLabel", "secondaryActionLabel", "cancelLabel", "autoFocusButton", "title", "isPrimaryActionDisabled", "isSecondaryActionDisabled", "onCancel", "onPrimaryAction", "onSecondaryAction"],
    _excluded4 = ["children", "type", "mobileType", "hideArrow", "targetRef", "isDismissable", "isKeyboardDismissDisabled"],
    _excluded5 = ["state", "targetRef", "trigger", "content", "hideArrow", "isKeyboardDismissDisabled"];
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "./main.css";
import $b4euU$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import { Button as $b4euU$Button, ActionButton as $b4euU$ActionButton } from "@react-spectrum/button";
import { ButtonGroup as $b4euU$ButtonGroup } from "@react-spectrum/buttongroup";
import { chain as $b4euU$chain, mergeProps as $b4euU$mergeProps } from "@react-aria/utils";
import { useStyleProps as $b4euU$useStyleProps, classNames as $b4euU$classNames, useDOMRef as $b4euU$useDOMRef, useHasChild as $b4euU$useHasChild, unwrapDOMRef as $b4euU$unwrapDOMRef, SlotProvider as $b4euU$SlotProvider, useMediaQuery as $b4euU$useMediaQuery } from "@react-spectrum/utils";
import { Content as $b4euU$Content } from "@react-spectrum/view";
import { Divider as $b4euU$Divider } from "@react-spectrum/divider";
import { Heading as $b4euU$Heading } from "@react-spectrum/text";
import $b4euU$react, { useContext as $b4euU$useContext, forwardRef as $b4euU$forwardRef, useRef as $b4euU$useRef, useMemo as $b4euU$useMemo, useEffect as $b4euU$useEffect, Fragment as $b4euU$Fragment } from "react";
import { useMessageFormatter as $b4euU$useMessageFormatter } from "@react-aria/i18n";
import $b4euU$spectrumiconsuiCrossLarge from "@spectrum-icons/ui/CrossLarge";
import { DismissButton as $b4euU$DismissButton, useOverlayPosition as $b4euU$useOverlayPosition, useOverlayTrigger as $b4euU$useOverlayTrigger } from "@react-aria/overlays";
import { FocusScope as $b4euU$FocusScope } from "@react-aria/focus";
import { Grid as $b4euU$Grid } from "@react-spectrum/layout";
import { useDialog as $b4euU$useDialog } from "@react-aria/dialog";
import { Modal as $b4euU$Modal, Tray as $b4euU$Tray, Popover as $b4euU$Popover } from "@react-spectrum/overlays";
import { useOverlayTriggerState as $b4euU$useOverlayTriggerState } from "@react-stately/overlays";
import { PressResponder as $b4euU$PressResponder } from "@react-aria/interactions";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $2a8395160fff9af3$exports = {};
$parcel$export($2a8395160fff9af3$exports, "AlertDialog", function () {
  return $2a8395160fff9af3$export$de466dd8317b0b75;
});
var $99cd51dc4eb569f7$exports = {};
$parcel$export($99cd51dc4eb569f7$exports, "Dialog", function () {
  return $99cd51dc4eb569f7$export$3ddf2d174ce01153;
});
var $97b119e05830ea0d$export$8b93a07348a7730c = $b4euU$react.createContext(null);
var $5c372ca6bd75272c$exports = {};
var $cc8cbf248c4ac933$exports = {};
$cc8cbf248c4ac933$exports = JSON.parse("{\"alert\":\"تنبيه\",\"dismiss\":\"تجاهل\"}");
var $c23042f930ed2466$exports = {};
$c23042f930ed2466$exports = JSON.parse("{\"alert\":\"Сигнал\",\"dismiss\":\"Отхвърляне\"}");
var $22339168a6e88f2f$exports = {};
$22339168a6e88f2f$exports = JSON.parse("{\"alert\":\"Výstraha\",\"dismiss\":\"Odstranit\"}");
var $ec8dd13b968e5322$exports = {};
$ec8dd13b968e5322$exports = JSON.parse("{\"alert\":\"Advarsel\",\"dismiss\":\"Luk\"}");
var $39167ee9a84b7061$exports = {};
$39167ee9a84b7061$exports = JSON.parse("{\"alert\":\"Warnhinweis\",\"dismiss\":\"Schließen\"}");
var $1704ee735c76afc9$exports = {};
$1704ee735c76afc9$exports = JSON.parse("{\"alert\":\"Ειδοποίηση\",\"dismiss\":\"Απόρριψη\"}");
var $0cb312c2797e7a68$exports = {};
$0cb312c2797e7a68$exports = JSON.parse("{\"dismiss\":\"Dismiss\",\"alert\":\"Alert\"}");
var $95df037910b72a83$exports = {};
$95df037910b72a83$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Descartar\"}");
var $9e83f2ab3a156c72$exports = {};
$9e83f2ab3a156c72$exports = JSON.parse("{\"alert\":\"Teade\",\"dismiss\":\"Lõpeta\"}");
var $f0c4e76101f61910$exports = {};
$f0c4e76101f61910$exports = JSON.parse("{\"alert\":\"Hälytys\",\"dismiss\":\"Hylkää\"}");
var $0e0388177f2c7eb2$exports = {};
$0e0388177f2c7eb2$exports = JSON.parse("{\"alert\":\"Alerte\",\"dismiss\":\"Rejeter\"}");
var $fd928d81cf33984c$exports = {};
$fd928d81cf33984c$exports = JSON.parse("{\"alert\":\"התראה\",\"dismiss\":\"התעלם\"}");
var $17a3672f010e4055$exports = {};
$17a3672f010e4055$exports = JSON.parse("{\"alert\":\"Upozorenje\",\"dismiss\":\"Odbaci\"}");
var $43993547bd42ef6e$exports = {};
$43993547bd42ef6e$exports = JSON.parse("{\"alert\":\"Figyelmeztetés\",\"dismiss\":\"Elutasítás\"}");
var $fca04de68cb5ade1$exports = {};
$fca04de68cb5ade1$exports = JSON.parse("{\"alert\":\"Avviso\",\"dismiss\":\"Ignora\"}");
var $0d47eca4edb370b0$exports = {};
$0d47eca4edb370b0$exports = JSON.parse("{\"alert\":\"アラート\",\"dismiss\":\"閉じる\"}");
var $d791c4a431b7a587$exports = {};
$d791c4a431b7a587$exports = JSON.parse("{\"alert\":\"경고\",\"dismiss\":\"무시\"}");
var $35175b1ad320fcc1$exports = {};
$35175b1ad320fcc1$exports = JSON.parse("{\"alert\":\"Įspėjimas\",\"dismiss\":\"Atmesti\"}");
var $b9d08f9d50543ce2$exports = {};
$b9d08f9d50543ce2$exports = JSON.parse("{\"alert\":\"Brīdinājums\",\"dismiss\":\"Nerādīt\"}");
var $20889bf3c0d36a01$exports = {};
$20889bf3c0d36a01$exports = JSON.parse("{\"alert\":\"Varsel\",\"dismiss\":\"Lukk\"}");
var $f694e1ecd0344008$exports = {};
$f694e1ecd0344008$exports = JSON.parse("{\"alert\":\"Melding\",\"dismiss\":\"Negeren\"}");
var $1b424c160db5642d$exports = {};
$1b424c160db5642d$exports = JSON.parse("{\"alert\":\"Ostrzeżenie\",\"dismiss\":\"Zignoruj\"}");
var $5d029553257fceab$exports = {};
$5d029553257fceab$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Descartar\"}");
var $2bea12bc13111737$exports = {};
$2bea12bc13111737$exports = JSON.parse("{\"alert\":\"Alerta\",\"dismiss\":\"Dispensar\"}");
var $12084690a0b76ac4$exports = {};
$12084690a0b76ac4$exports = JSON.parse("{\"alert\":\"Alertă\",\"dismiss\":\"Revocare\"}");
var $697f8e526692bd95$exports = {};
$697f8e526692bd95$exports = JSON.parse("{\"alert\":\"Предупреждение\",\"dismiss\":\"Пропустить\"}");
var $0802ec67729008c5$exports = {};
$0802ec67729008c5$exports = JSON.parse("{\"alert\":\"Upozornenie\",\"dismiss\":\"Zrušiť\"}");
var $ef29867297882921$exports = {};
$ef29867297882921$exports = JSON.parse("{\"alert\":\"Opozorilo\",\"dismiss\":\"Opusti\"}");
var $39eb6836bb014970$exports = {};
$39eb6836bb014970$exports = JSON.parse("{\"alert\":\"Upozorenje\",\"dismiss\":\"Odbaci\"}");
var $b4fa8198ca731e89$exports = {};
$b4fa8198ca731e89$exports = JSON.parse("{\"alert\":\"Varning\",\"dismiss\":\"Avvisa\"}");
var $862832bdcbb90256$exports = {};
$862832bdcbb90256$exports = JSON.parse("{\"alert\":\"Uyarı\",\"dismiss\":\"Kapat\"}");
var $2fa80cee796b989c$exports = {};
$2fa80cee796b989c$exports = JSON.parse("{\"alert\":\"Сигнал тривоги\",\"dismiss\":\"Скасувати\"}");
var $ecd80835333d83cc$exports = {};
$ecd80835333d83cc$exports = JSON.parse("{\"alert\":\"警报\",\"dismiss\":\"取消\"}");
var $03712eabbcfd201c$exports = {};
$03712eabbcfd201c$exports = JSON.parse("{\"alert\":\"警示\",\"dismiss\":\"關閉\"}");
$5c372ca6bd75272c$exports = {
  "ar-AE": $cc8cbf248c4ac933$exports,
  "bg-BG": $c23042f930ed2466$exports,
  "cs-CZ": $22339168a6e88f2f$exports,
  "da-DK": $ec8dd13b968e5322$exports,
  "de-DE": $39167ee9a84b7061$exports,
  "el-GR": $1704ee735c76afc9$exports,
  "en-US": $0cb312c2797e7a68$exports,
  "es-ES": $95df037910b72a83$exports,
  "et-EE": $9e83f2ab3a156c72$exports,
  "fi-FI": $f0c4e76101f61910$exports,
  "fr-FR": $0e0388177f2c7eb2$exports,
  "he-IL": $fd928d81cf33984c$exports,
  "hr-HR": $17a3672f010e4055$exports,
  "hu-HU": $43993547bd42ef6e$exports,
  "it-IT": $fca04de68cb5ade1$exports,
  "ja-JP": $0d47eca4edb370b0$exports,
  "ko-KR": $d791c4a431b7a587$exports,
  "lt-LT": $35175b1ad320fcc1$exports,
  "lv-LV": $b9d08f9d50543ce2$exports,
  "nb-NO": $20889bf3c0d36a01$exports,
  "nl-NL": $f694e1ecd0344008$exports,
  "pl-PL": $1b424c160db5642d$exports,
  "pt-BR": $5d029553257fceab$exports,
  "pt-PT": $2bea12bc13111737$exports,
  "ro-RO": $12084690a0b76ac4$exports,
  "ru-RU": $697f8e526692bd95$exports,
  "sk-SK": $0802ec67729008c5$exports,
  "sl-SI": $ef29867297882921$exports,
  "sr-SP": $39eb6836bb014970$exports,
  "sv-SE": $b4fa8198ca731e89$exports,
  "tr-TR": $862832bdcbb90256$exports,
  "uk-UA": $2fa80cee796b989c$exports,
  "zh-CN": $ecd80835333d83cc$exports,
  "zh-TW": $03712eabbcfd201c$exports
};
var $78859b019f1ff3c5$exports = {};
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog", function () {
  return $78859b019f1ff3c5$export$4681f3bcac39b2b1;
}, function (v) {
  return $78859b019f1ff3c5$export$4681f3bcac39b2b1 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--small", function () {
  return $78859b019f1ff3c5$export$5f2d9cc47409bd63;
}, function (v) {
  return $78859b019f1ff3c5$export$5f2d9cc47409bd63 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--medium", function () {
  return $78859b019f1ff3c5$export$b9b8ef443d0a67ca;
}, function (v) {
  return $78859b019f1ff3c5$export$b9b8ef443d0a67ca = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--large", function () {
  return $78859b019f1ff3c5$export$b73c0c2fca84be2b;
}, function (v) {
  return $78859b019f1ff3c5$export$b73c0c2fca84be2b = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-hero", function () {
  return $78859b019f1ff3c5$export$d405fb0a0231aa1a;
}, function (v) {
  return $78859b019f1ff3c5$export$d405fb0a0231aa1a = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-grid", function () {
  return $78859b019f1ff3c5$export$c03cd5e23af67ff5;
}, function (v) {
  return $78859b019f1ff3c5$export$c03cd5e23af67ff5 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-heading", function () {
  return $78859b019f1ff3c5$export$94335d73b7b209ec;
}, function (v) {
  return $78859b019f1ff3c5$export$94335d73b7b209ec = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-heading--noHeader", function () {
  return $78859b019f1ff3c5$export$ade8307239736e89;
}, function (v) {
  return $78859b019f1ff3c5$export$ade8307239736e89 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-header", function () {
  return $78859b019f1ff3c5$export$1e158eaa6363e131;
}, function (v) {
  return $78859b019f1ff3c5$export$1e158eaa6363e131 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-typeIcon", function () {
  return $78859b019f1ff3c5$export$5beee9480fc6ff07;
}, function (v) {
  return $78859b019f1ff3c5$export$5beee9480fc6ff07 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-divider", function () {
  return $78859b019f1ff3c5$export$dd7633d642d0bc1c;
}, function (v) {
  return $78859b019f1ff3c5$export$dd7633d642d0bc1c = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--noDivider", function () {
  return $78859b019f1ff3c5$export$22425527a8943917;
}, function (v) {
  return $78859b019f1ff3c5$export$22425527a8943917 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-content", function () {
  return $78859b019f1ff3c5$export$cb8eccd0f3639238;
}, function (v) {
  return $78859b019f1ff3c5$export$cb8eccd0f3639238 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-footer", function () {
  return $78859b019f1ff3c5$export$3ecb5025a06fe08f;
}, function (v) {
  return $78859b019f1ff3c5$export$3ecb5025a06fe08f = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Button", function () {
  return $78859b019f1ff3c5$export$1db4cca5b4ade39a;
}, function (v) {
  return $78859b019f1ff3c5$export$1db4cca5b4ade39a = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-buttonGroup", function () {
  return $78859b019f1ff3c5$export$570ae852861555b7;
}, function (v) {
  return $78859b019f1ff3c5$export$570ae852861555b7 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-buttonGroup--noFooter", function () {
  return $78859b019f1ff3c5$export$39dd75369bf2e830;
}, function (v) {
  return $78859b019f1ff3c5$export$39dd75369bf2e830 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--dismissable", function () {
  return $78859b019f1ff3c5$export$9461b285d631d575;
}, function (v) {
  return $78859b019f1ff3c5$export$9461b285d631d575 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog-closeButton", function () {
  return $78859b019f1ff3c5$export$a8494287d763a75d;
}, function (v) {
  return $78859b019f1ff3c5$export$a8494287d763a75d = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--error", function () {
  return $78859b019f1ff3c5$export$6b5beff56972a3b;
}, function (v) {
  return $78859b019f1ff3c5$export$6b5beff56972a3b = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--fullscreen", function () {
  return $78859b019f1ff3c5$export$118506da5d3ee7c4;
}, function (v) {
  return $78859b019f1ff3c5$export$118506da5d3ee7c4 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--fullscreenTakeover", function () {
  return $78859b019f1ff3c5$export$5c061b2d3664fda9;
}, function (v) {
  return $78859b019f1ff3c5$export$5c061b2d3664fda9 = v;
});
$parcel$export($78859b019f1ff3c5$exports, "spectrum-Dialog--warning", function () {
  return $78859b019f1ff3c5$export$4e66396adf61534f;
}, function (v) {
  return $78859b019f1ff3c5$export$4e66396adf61534f = v;
});
var $78859b019f1ff3c5$export$4681f3bcac39b2b1;
var $78859b019f1ff3c5$export$5f2d9cc47409bd63;
var $78859b019f1ff3c5$export$b9b8ef443d0a67ca;
var $78859b019f1ff3c5$export$b73c0c2fca84be2b;
var $78859b019f1ff3c5$export$d405fb0a0231aa1a;
var $78859b019f1ff3c5$export$c03cd5e23af67ff5;
var $78859b019f1ff3c5$export$94335d73b7b209ec;
var $78859b019f1ff3c5$export$ade8307239736e89;
var $78859b019f1ff3c5$export$1e158eaa6363e131;
var $78859b019f1ff3c5$export$5beee9480fc6ff07;
var $78859b019f1ff3c5$export$dd7633d642d0bc1c;
var $78859b019f1ff3c5$export$22425527a8943917;
var $78859b019f1ff3c5$export$cb8eccd0f3639238;
var $78859b019f1ff3c5$export$3ecb5025a06fe08f;
var $78859b019f1ff3c5$export$1db4cca5b4ade39a;
var $78859b019f1ff3c5$export$570ae852861555b7;
var $78859b019f1ff3c5$export$39dd75369bf2e830;
var $78859b019f1ff3c5$export$9461b285d631d575;
var $78859b019f1ff3c5$export$a8494287d763a75d;
var $78859b019f1ff3c5$export$6b5beff56972a3b;
var $78859b019f1ff3c5$export$118506da5d3ee7c4;
var $78859b019f1ff3c5$export$5c061b2d3664fda9;
var $78859b019f1ff3c5$export$4e66396adf61534f;
$78859b019f1ff3c5$export$4681f3bcac39b2b1 = "spectrum-Dialog_6d8b48";
$78859b019f1ff3c5$export$5f2d9cc47409bd63 = "spectrum-Dialog--small_6d8b48";
$78859b019f1ff3c5$export$b9b8ef443d0a67ca = "spectrum-Dialog--medium_6d8b48";
$78859b019f1ff3c5$export$b73c0c2fca84be2b = "spectrum-Dialog--large_6d8b48";
$78859b019f1ff3c5$export$d405fb0a0231aa1a = "spectrum-Dialog-hero_6d8b48";
$78859b019f1ff3c5$export$c03cd5e23af67ff5 = "spectrum-Dialog-grid_6d8b48";
$78859b019f1ff3c5$export$94335d73b7b209ec = "spectrum-Dialog-heading_6d8b48";
$78859b019f1ff3c5$export$ade8307239736e89 = "spectrum-Dialog-heading--noHeader_6d8b48";
$78859b019f1ff3c5$export$1e158eaa6363e131 = "spectrum-Dialog-header_6d8b48";
$78859b019f1ff3c5$export$5beee9480fc6ff07 = "spectrum-Dialog-typeIcon_6d8b48";
$78859b019f1ff3c5$export$dd7633d642d0bc1c = "spectrum-Dialog-divider_6d8b48";
$78859b019f1ff3c5$export$22425527a8943917 = "spectrum-Dialog--noDivider_6d8b48";
$78859b019f1ff3c5$export$cb8eccd0f3639238 = "spectrum-Dialog-content_6d8b48";
$78859b019f1ff3c5$export$3ecb5025a06fe08f = "spectrum-Dialog-footer_6d8b48";
$78859b019f1ff3c5$export$1db4cca5b4ade39a = "spectrum-Button_6d8b48";
$78859b019f1ff3c5$export$570ae852861555b7 = "spectrum-Dialog-buttonGroup_6d8b48";
$78859b019f1ff3c5$export$39dd75369bf2e830 = "spectrum-Dialog-buttonGroup--noFooter_6d8b48";
$78859b019f1ff3c5$export$9461b285d631d575 = "spectrum-Dialog--dismissable_6d8b48";
$78859b019f1ff3c5$export$a8494287d763a75d = "spectrum-Dialog-closeButton_6d8b48";
$78859b019f1ff3c5$export$6b5beff56972a3b = "spectrum-Dialog--error_6d8b48";
$78859b019f1ff3c5$export$118506da5d3ee7c4 = "spectrum-Dialog--fullscreen_6d8b48";
$78859b019f1ff3c5$export$5c061b2d3664fda9 = "spectrum-Dialog--fullscreenTakeover_6d8b48";
$78859b019f1ff3c5$export$4e66396adf61534f = "spectrum-Dialog--warning_6d8b48";
var $99cd51dc4eb569f7$var$sizeMap = {
  S: 'small',
  M: 'medium',
  L: 'large',
  fullscreen: 'fullscreen',
  fullscreenTakeover: 'fullscreenTakeover'
};

function $99cd51dc4eb569f7$var$Dialog(props, ref) {
  var _$b4euU$classNames;

  var _ref = $b4euU$useContext($97b119e05830ea0d$export$8b93a07348a7730c) || {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'modal' : _ref$type,
      contextProps = _objectWithoutProperties(_ref, _excluded);

  var children = props.children,
      _props$isDismissable = props.isDismissable,
      isDismissable = _props$isDismissable === void 0 ? contextProps.isDismissable : _props$isDismissable,
      _props$onDismiss = props.onDismiss,
      onDismiss = _props$onDismiss === void 0 ? contextProps.onClose : _props$onDismiss,
      size = props.size,
      otherProps = _objectWithoutProperties(props, _excluded2);

  var formatMessage = $b4euU$useMessageFormatter( /*@__PURE__*/$parcel$interopDefault($5c372ca6bd75272c$exports));

  var _$b4euU$useStyleProps = $b4euU$useStyleProps(otherProps),
      styleProps = _$b4euU$useStyleProps.styleProps;

  size = type === 'popover' ? size || 'S' : size || 'L';
  var domRef = $b4euU$useDOMRef(ref);
  var gridRef = $b4euU$useRef();
  var sizeVariant = $99cd51dc4eb569f7$var$sizeMap[type] || $99cd51dc4eb569f7$var$sizeMap[size];

  var _$b4euU$useDialog = $b4euU$useDialog($b4euU$mergeProps(contextProps, props), domRef),
      dialogProps = _$b4euU$useDialog.dialogProps,
      titleProps = _$b4euU$useDialog.titleProps;

  var hasHeader = $b4euU$useHasChild(".".concat( /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-header']), $b4euU$unwrapDOMRef(gridRef));
  var hasFooter = $b4euU$useHasChild(".".concat( /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-footer']), $b4euU$unwrapDOMRef(gridRef));
  var slots = $b4euU$useMemo(function () {
    return {
      hero: {
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-hero']
      },
      header: {
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-header']
      },
      heading: _objectSpread({
        UNSAFE_className: $b4euU$classNames( /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports), 'spectrum-Dialog-heading', {
          'spectrum-Dialog-heading--noHeader': !hasHeader
        }),
        level: 2
      }, titleProps),
      typeIcon: {
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-typeIcon']
      },
      divider: {
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-divider'],
        size: 'M'
      },
      content: {
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-content']
      },
      footer: {
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-footer']
      },
      buttonGroup: {
        UNSAFE_className: $b4euU$classNames( /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports), 'spectrum-Dialog-buttonGroup', {
          'spectrum-Dialog-buttonGroup--noFooter': !hasFooter
        }),
        align: 'end'
      }
    };
  }, [/*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports), hasFooter, hasHeader, titleProps]); // If rendered in a popover or tray there won't be a visible dismiss button,
  // so we render a hidden one for screen readers.

  var dismissButton;
  if (type === 'popover' || type === 'tray') dismissButton = /*#__PURE__*/$b4euU$react.createElement($b4euU$DismissButton, {
    onDismiss: onDismiss
  });
  return /*#__PURE__*/$b4euU$react.createElement($b4euU$FocusScope, {
    contain: true,
    restoreFocus: true
  }, /*#__PURE__*/$b4euU$react.createElement("section", _objectSpread(_objectSpread(_objectSpread({}, styleProps), dialogProps), {}, {
    className: $b4euU$classNames( /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports), 'spectrum-Dialog', (_$b4euU$classNames = {}, _defineProperty(_$b4euU$classNames, "spectrum-Dialog--".concat(sizeVariant), sizeVariant), _defineProperty(_$b4euU$classNames, 'spectrum-Dialog--dismissable', isDismissable), _$b4euU$classNames), styleProps.className),
    ref: domRef
  }), /*#__PURE__*/$b4euU$react.createElement($b4euU$Grid, {
    ref: gridRef,
    UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-grid']
  }, /*#__PURE__*/$b4euU$react.createElement($b4euU$SlotProvider, {
    slots: slots
  }, children), isDismissable && /*#__PURE__*/$b4euU$react.createElement($b4euU$ActionButton, {
    UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports)['spectrum-Dialog-closeButton'],
    isQuiet: true,
    "aria-label": formatMessage('dismiss'),
    onPress: onDismiss
  }, /*#__PURE__*/$b4euU$react.createElement($b4euU$spectrumiconsuiCrossLarge, null))), dismissButton));
}
/**
 * Dialogs are windows containing contextual information, tasks, or workflows that appear over the user interface.
 * Depending on the kind of Dialog, further interactions may be blocked until the Dialog is acknowledged.
 */


var $99cd51dc4eb569f7$export$3ddf2d174ce01153 = /*#__PURE__*/$b4euU$react.forwardRef($99cd51dc4eb569f7$var$Dialog);
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */

function $2a8395160fff9af3$var$AlertDialog(props, ref) {
  var _ref2 = $b4euU$useContext($97b119e05830ea0d$export$8b93a07348a7730c) || {},
      _ref2$onClose = _ref2.onClose,
      onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose;

  var variant = props.variant,
      children = props.children,
      primaryActionLabel = props.primaryActionLabel,
      secondaryActionLabel = props.secondaryActionLabel,
      cancelLabel = props.cancelLabel,
      autoFocusButton = props.autoFocusButton,
      title = props.title,
      isPrimaryActionDisabled = props.isPrimaryActionDisabled,
      isSecondaryActionDisabled = props.isSecondaryActionDisabled,
      _props$onCancel = props.onCancel,
      onCancel = _props$onCancel === void 0 ? function () {} : _props$onCancel,
      _props$onPrimaryActio = props.onPrimaryAction,
      onPrimaryAction = _props$onPrimaryActio === void 0 ? function () {} : _props$onPrimaryActio,
      _props$onSecondaryAct = props.onSecondaryAction,
      onSecondaryAction = _props$onSecondaryAct === void 0 ? function () {} : _props$onSecondaryAct,
      otherProps = _objectWithoutProperties(props, _excluded3);

  var _$b4euU$useStyleProps2 = $b4euU$useStyleProps(otherProps),
      styleProps = _$b4euU$useStyleProps2.styleProps;

  var formatMessage = $b4euU$useMessageFormatter( /*@__PURE__*/$parcel$interopDefault($5c372ca6bd75272c$exports));
  var confirmVariant = 'primary';

  if (variant) {
    if (variant === 'confirmation') confirmVariant = 'cta';else if (variant === 'destructive') confirmVariant = 'negative';
  }

  return /*#__PURE__*/$b4euU$react.createElement($99cd51dc4eb569f7$export$3ddf2d174ce01153, {
    UNSAFE_style: styleProps.style,
    UNSAFE_className: $b4euU$classNames( /*@__PURE__*/$parcel$interopDefault($78859b019f1ff3c5$exports), _defineProperty({}, "spectrum-Dialog--".concat(variant), variant), styleProps.className),
    isHidden: styleProps.hidden,
    size: "M",
    role: "alertdialog",
    ref: ref
  }, /*#__PURE__*/$b4euU$react.createElement($b4euU$Heading, null, title), (variant === 'error' || variant === 'warning') && /*#__PURE__*/$b4euU$react.createElement($b4euU$spectrumiconsuiAlertMedium, {
    slot: "typeIcon",
    "aria-label": formatMessage('alert')
  }), /*#__PURE__*/$b4euU$react.createElement($b4euU$Divider, null), /*#__PURE__*/$b4euU$react.createElement($b4euU$Content, null, children), /*#__PURE__*/$b4euU$react.createElement($b4euU$ButtonGroup, {
    align: "end"
  }, cancelLabel && /*#__PURE__*/$b4euU$react.createElement($b4euU$Button, {
    variant: "secondary",
    onPress: function onPress() {
      return $b4euU$chain(onClose(), onCancel());
    },
    autoFocus: autoFocusButton === 'cancel'
  }, cancelLabel), secondaryActionLabel && /*#__PURE__*/$b4euU$react.createElement($b4euU$Button, {
    variant: "secondary",
    onPress: function onPress() {
      return $b4euU$chain(onClose(), onSecondaryAction());
    },
    isDisabled: isSecondaryActionDisabled,
    autoFocus: autoFocusButton === 'secondary'
  }, secondaryActionLabel), /*#__PURE__*/$b4euU$react.createElement($b4euU$Button, {
    variant: confirmVariant,
    onPress: function onPress() {
      return $b4euU$chain(onClose(), onPrimaryAction());
    },
    isDisabled: isPrimaryActionDisabled,
    autoFocus: autoFocusButton === 'primary'
  }, primaryActionLabel)));
}
/**
 * AlertDialogs are a specific type of Dialog. They display important information that users need to acknowledge.
 */


var $2a8395160fff9af3$export$de466dd8317b0b75 = /*#__PURE__*/$b4euU$forwardRef($2a8395160fff9af3$var$AlertDialog);
var $c412c5ea680c1e4f$exports = {};
$parcel$export($c412c5ea680c1e4f$exports, "DialogTrigger", function () {
  return $c412c5ea680c1e4f$export$2e1e1122cf0cba88;
});

function $c412c5ea680c1e4f$var$DialogTrigger(props) {
  var children = props.children,
      _props$type = props.type,
      type = _props$type === void 0 ? 'modal' : _props$type,
      _props$mobileType = props.mobileType,
      mobileType = _props$mobileType === void 0 ? type === 'popover' ? 'modal' : type : _props$mobileType,
      hideArrow = props.hideArrow,
      targetRef = props.targetRef,
      isDismissable = props.isDismissable,
      isKeyboardDismissDisabled = props.isKeyboardDismissDisabled,
      positionProps = _objectWithoutProperties(props, _excluded4);

  if (!Array.isArray(children) || children.length > 2) throw new Error('DialogTrigger must have exactly 2 children'); // if a function is passed as the second child, it won't appear in toArray

  var _children = _slicedToArray(children, 2),
      trigger = _children[0],
      content = _children[1]; // On small devices, show a modal or tray instead of a popover.
  // TODO: DNA variable?


  var isMobile = $b4euU$useMediaQuery('(max-width: 700px)');

  if (isMobile) {
    // handle cases where desktop popovers need a close button for the mobile modal view
    if (type !== 'modal' && mobileType === 'modal') isDismissable = true;
    type = mobileType;
  }

  var state = $b4euU$useOverlayTriggerState(props);
  var wasOpen = $b4euU$useRef(false);
  wasOpen.current = state.isOpen;
  var isExiting = $b4euU$useRef(false);

  var onExiting = function onExiting() {
    return isExiting.current = true;
  };

  var onExited = function onExited() {
    return isExiting.current = false;
  }; // eslint-disable-next-line arrow-body-style


  $b4euU$useEffect(function () {
    return function () {
      if ((wasOpen.current || isExiting.current) && type !== 'popover' && type !== 'tray') console.warn('A DialogTrigger unmounted while open. This is likely due to being placed within a trigger that unmounts or inside a conditional. Consider using a DialogContainer instead.');
    };
  }, []);
  if (type === 'popover') return /*#__PURE__*/$b4euU$react.createElement($c412c5ea680c1e4f$var$PopoverTrigger, _objectSpread(_objectSpread({}, positionProps), {}, {
    state: state,
    targetRef: targetRef,
    trigger: trigger,
    content: content,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
    hideArrow: hideArrow
  }));

  var renderOverlay = function renderOverlay() {
    switch (type) {
      case 'fullscreen':
      case 'fullscreenTakeover':
      case 'modal':
        return /*#__PURE__*/$b4euU$react.createElement($b4euU$Modal, {
          isOpen: state.isOpen,
          isDismissable: type === 'modal' ? isDismissable : false,
          onClose: state.close,
          type: type,
          isKeyboardDismissDisabled: isKeyboardDismissDisabled,
          onExiting: onExiting,
          onExited: onExited
        }, typeof content === 'function' ? content(state.close) : content);

      case 'tray':
        return /*#__PURE__*/$b4euU$react.createElement($b4euU$Tray, {
          isOpen: state.isOpen,
          onClose: state.close,
          isKeyboardDismissDisabled: isKeyboardDismissDisabled
        }, typeof content === 'function' ? content(state.close) : content);
    }
  };

  return /*#__PURE__*/$b4euU$react.createElement($c412c5ea680c1e4f$var$DialogTriggerBase, {
    type: type,
    state: state,
    isDismissable: isDismissable,
    trigger: trigger,
    overlay: renderOverlay()
  });
} // Support DialogTrigger inside components using CollectionBuilder.


$c412c5ea680c1e4f$var$DialogTrigger.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function _callee(props) {
  var _$b4euU$react$Childre, _$b4euU$react$Childre2, trigger, _props$children, content;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _$b4euU$react$Childre = $b4euU$react.Children.toArray(props.children), _$b4euU$react$Childre2 = _slicedToArray(_$b4euU$react$Childre, 1), trigger = _$b4euU$react$Childre2[0];
          _props$children = _slicedToArray(props.children, 2), content = _props$children[1];
          _context.next = 4;
          return {
            element: trigger,
            wrapper: function wrapper(element) {
              return /*#__PURE__*/$b4euU$react.createElement($c412c5ea680c1e4f$var$DialogTrigger, _objectSpread({
                key: element.key
              }, props), element, content);
            }
          };

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
});
/**
 * DialogTrigger serves as a wrapper around a Dialog and its associated trigger, linking the Dialog's
 * open state with the trigger's press state. Additionally, it allows you to customize the type and
 * positioning of the Dialog.
 */
// We don't want getCollectionNode to show up in the type definition

var $c412c5ea680c1e4f$export$2e1e1122cf0cba88 = $c412c5ea680c1e4f$var$DialogTrigger;

function $c412c5ea680c1e4f$var$PopoverTrigger(_ref3) {
  var state = _ref3.state,
      targetRef = _ref3.targetRef,
      trigger = _ref3.trigger,
      content = _ref3.content,
      hideArrow = _ref3.hideArrow,
      isKeyboardDismissDisabled = _ref3.isKeyboardDismissDisabled,
      props = _objectWithoutProperties(_ref3, _excluded5);

  var triggerRef = $b4euU$useRef();
  var overlayRef = $b4euU$useRef();

  var _$b4euU$useOverlayPos = $b4euU$useOverlayPosition({
    targetRef: targetRef || triggerRef,
    overlayRef: $b4euU$unwrapDOMRef(overlayRef),
    placement: props.placement,
    containerPadding: props.containerPadding,
    offset: props.offset,
    crossOffset: props.crossOffset,
    shouldFlip: props.shouldFlip,
    isOpen: state.isOpen
  }),
      popoverProps = _$b4euU$useOverlayPos.overlayProps,
      placement = _$b4euU$useOverlayPos.placement,
      arrowProps = _$b4euU$useOverlayPos.arrowProps;

  var _$b4euU$useOverlayTri = $b4euU$useOverlayTrigger({
    type: 'dialog'
  }, state, triggerRef),
      triggerProps = _$b4euU$useOverlayTri.triggerProps,
      overlayProps = _$b4euU$useOverlayTri.overlayProps;

  var triggerPropsWithRef = _objectSpread(_objectSpread({}, triggerProps), {}, {
    ref: targetRef ? undefined : triggerRef
  });

  var overlay = /*#__PURE__*/$b4euU$react.createElement($b4euU$Popover, {
    isOpen: state.isOpen,
    UNSAFE_style: popoverProps.style,
    ref: overlayRef,
    onClose: state.close,
    placement: placement,
    arrowProps: arrowProps,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
    hideArrow: hideArrow
  }, typeof content === 'function' ? content(state.close) : content);
  return /*#__PURE__*/$b4euU$react.createElement($c412c5ea680c1e4f$var$DialogTriggerBase, {
    type: "popover",
    state: state,
    triggerProps: triggerPropsWithRef,
    dialogProps: overlayProps,
    trigger: trigger,
    overlay: overlay
  });
}

function $c412c5ea680c1e4f$var$DialogTriggerBase(_ref4) {
  var type = _ref4.type,
      state = _ref4.state,
      isDismissable = _ref4.isDismissable,
      _ref4$dialogProps = _ref4.dialogProps,
      dialogProps = _ref4$dialogProps === void 0 ? {} : _ref4$dialogProps,
      _ref4$triggerProps = _ref4.triggerProps,
      triggerProps = _ref4$triggerProps === void 0 ? {} : _ref4$triggerProps,
      overlay = _ref4.overlay,
      trigger = _ref4.trigger;

  var context = _objectSpread({
    type: type,
    onClose: state.close,
    isDismissable: isDismissable
  }, dialogProps);

  return /*#__PURE__*/$b4euU$react.createElement($b4euU$Fragment, null, /*#__PURE__*/$b4euU$react.createElement($b4euU$PressResponder, _objectSpread(_objectSpread({}, triggerProps), {}, {
    onPress: state.toggle,
    isPressed: state.isOpen && type !== 'modal' && type !== 'fullscreen' && type !== 'fullscreenTakeover'
  }), trigger), /*#__PURE__*/$b4euU$react.createElement($97b119e05830ea0d$export$8b93a07348a7730c.Provider, {
    value: context
  }, overlay));
}

var $2a9f0ad39ddaa8d9$exports = {};
$parcel$export($2a9f0ad39ddaa8d9$exports, "DialogContainer", function () {
  return $2a9f0ad39ddaa8d9$export$547754aada6e339f;
});

function $2a9f0ad39ddaa8d9$export$547754aada6e339f(props) {
  var children = props.children,
      _props$type2 = props.type,
      type = _props$type2 === void 0 ? 'modal' : _props$type2,
      onDismiss = props.onDismiss,
      isDismissable = props.isDismissable,
      isKeyboardDismissDisabled = props.isKeyboardDismissDisabled;
  var childArray = $b4euU$react.Children.toArray(children);
  if (childArray.length > 1) throw new Error('Only a single child can be passed to DialogContainer.');
  var lastChild = $b4euU$useRef(null);
  var child = /*#__PURE__*/$b4euU$react.isValidElement(childArray[0]) ? childArray[0] : null;
  if (child) lastChild.current = child;
  var context = {
    type: type,
    onClose: onDismiss,
    isDismissable: isDismissable
  };
  return /*#__PURE__*/$b4euU$react.createElement($b4euU$Modal, {
    isOpen: !!child,
    onClose: onDismiss,
    type: type,
    isDismissable: isDismissable,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled
  }, /*#__PURE__*/$b4euU$react.createElement($97b119e05830ea0d$export$8b93a07348a7730c.Provider, {
    value: context
  }, lastChild.current));
}

var $faffee7da30e8f89$exports = {};
$parcel$export($faffee7da30e8f89$exports, "useDialogContainer", function () {
  return $faffee7da30e8f89$export$a2f2d8fa6720dab1;
});

function $faffee7da30e8f89$export$a2f2d8fa6720dab1() {
  var context = $b4euU$useContext($97b119e05830ea0d$export$8b93a07348a7730c);
  if (!context) throw new Error('Cannot call useDialogContext outside a <DialogTrigger> or <DialogContainer>.');
  return {
    type: context.type,
    dismiss: function dismiss() {
      context.onClose();
    }
  };
}

export { $2a8395160fff9af3$export$de466dd8317b0b75 as AlertDialog, $99cd51dc4eb569f7$export$3ddf2d174ce01153 as Dialog, $c412c5ea680c1e4f$export$2e1e1122cf0cba88 as DialogTrigger, $2a9f0ad39ddaa8d9$export$547754aada6e339f as DialogContainer, $faffee7da30e8f89$export$a2f2d8fa6720dab1 as useDialogContainer };